import { render, staticRenderFns } from "./checkboxes_multi.vue?vue&type=template&id=d3ba54c8"
import script from "./checkboxes_multi.js?vue&type=script&lang=js&external"
export * from "./checkboxes_multi.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports